import { computed } from "vue";
import store from "@/store";
import { useLog } from "@/use/use-log";
import { ApiError } from "@/types/common";

export const useApiErrorHandler = () => {
  /** APIでエラーが発生した場合のハンドリング */
  const handleApiError = computed(() => {
    const apiError: ApiError = store.getters["common/getApiError"];

    if (apiError) {
      // ログ出力
      // eslint-disable-next-line
      useLog().outputPageLogs(`${""},${apiError.error?.message ? apiError.error?.message : ""},${apiError.error?.code ? apiError.error?.code : ""}`);
    }

    return apiError;
  });

  /** APIでエラーが発生した際に表示するエラータイトルを取得 */
  const getApiErrorTitle = computed(() => {
    const apiError = store.getters["common/getApiError"];
    if (apiError && apiError.error && !apiError.error.code) {
      // サーバエラーでない場合は、タイトルを返す
      return apiError.title;
    }

    // エラーが発生してない場合は、または、サーバエラーの場合は、から文字を応答
    return "";
  });

  /** APIでエラーが発生した際に表示するエラー文言を取得 */
  const getApiErrorMessage = computed(() => {
    const apiError = store.getters["common/getApiError"];
    if (apiError && apiError.error) {
      if (apiError.error.code) {
        // エラーコードが存在する場合は、 {エラーメッセージ}\n({エラーコード}) の
        // フォーマットに変換
        console.log("useApiErrorHandler getApiErrorMessage error = " + apiError.error.message + ", code = " + apiError.error.code);
        return `${apiError.error.message}\n(${apiError.error.code})`;
      }
      console.log("useApiErrorHandler getApiErrorMessage error = " + apiError.error.message);
      return apiError.error.message;
    }

    // エラーが発生してない場合は、から文字を応答
    return "";
  });

  return {
    handleApiError,
    getApiErrorTitle,
    getApiErrorMessage
  };
};
